import faq from "../../partials/faq/faq.html";

(function($){

    let hash = window.location.hash.replace('#', '') || '';
        
    if(hash && hash.indexOf("collapse") >= 0) {

        $([document.documentElement, document.body]).animate({
            scrollTop: document.body.scrollHeight
        }, 2000);
    } 

      
    let footerLoaded = false;

    let faq_wrapper = $('.faq-wrapper');
    let loadingFaq = false, faqLoaded = false;

    function addFaq(){
        faq_wrapper.html(faq);
        loadingFaq = false;
        faqLoaded = true;

        if(hash && hash !== ''){
            let q_num = hash.replace('collapse', '');
            $(".panel#q"+q_num + " .panel-heading").click();
        }
        
    }

    window.addFaq = addFaq;

    function doScrolling() {

        if (!loadingFaq && faq_wrapper.html().trim() === '' && window.isInViewport(faq_wrapper)) {
            loadingFaq = true;
            !faqLoaded && window.addFaq();
        }

        if(!footerLoaded && $('.footer-links-wrapper .footer-links').length > 0){
            footerLoaded = true;
            $(".faq-link").click(function(){
                let q_num = $(this).data('faq');
                $(".panel#q"+q_num + " .panel-heading").click();
              });
        }
    }

    window.scrollingTasks.push(doScrolling);

    
})(window.jQuery);






